import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { isWhiteColor, removeDefaultParams } from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import {
  cardServedEvent,
  clickCardEvent,
} from '../../../Utils/StoreHomePageUtils';
import { getSearchParams } from '../../Parenting/common';
import { BannerSubTitle, BannerTitle } from '../BannersGrid/styled';
import {
  BrowseCategoryName,
  BrowseCatStyled,
  BrowseCatWrapper,
  BrowseImageBox,
} from './styled';

export default function BrowseCategoryHome(props) {
  const {
    categoryData,
    noMwebPadding,
    fromSuccessPage,
    parentIndex,
    textWidget,
    isParentingPage,
    fromBabyNames,
    fromSearchPage,
  } = props;
  const [clickEffect, setClickEffect] = useState({ class: '', index: null });
  // const { type } = props;
  const router = useRouter();
  const items = categoryData?.items || categoryData;
  const categoryClickHandler = (e, category, index) => {
    e.preventDefault();
    setClickEffect({ class: 'lowOpacity', index });
    setTimeout(() => {
      router.push(category?.deeplinkValue + getSearchParams(), '', {
        locale: getRouterLocale(router),
      });
    }, [200]);
    const sectionDetails = {
      heading: categoryData?.heading,
      itemId: categoryData?._id,
      position: parentIndex,
    };
    clickCardEvent(category, sectionDetails, isParentingPage);
  };
  useEffect(() => {
    cardServedEvent(categoryData, isParentingPage);
  }, []);
  const getDesktopImage = (category) => {
    // return category.desktopImage || category.image || category.icon;
    return category.desktopIcon || category.icon || category.image;
  };
  const getMobileImage = (category) => {
    // return category.image || category.desktopImage || category.icon;
    return category.mobileWebIcon || category.icon || category.image;
  };
  return (
    <BrowseCatWrapper
      sectionBgColorEnd={categoryData?.sectionBgColorEnd}
      sectionBgColorStart={categoryData?.sectionBgColorStart}
      padding={
        !isWhiteColor(
          categoryData?.sectionBgColorStart,
          categoryData?.sectionBgColorEnd,
        )
      }
      noMwebPadding={noMwebPadding}
      fromSuccessPage={fromSuccessPage}
      noPadding={true}
      fromSearchPage={fromSearchPage}
    >
      <BannerTitle
        textWidget={textWidget}
        fromSuccessPage={fromSuccessPage}
        fromBabyNames={fromBabyNames}
        subHeading={categoryData?.subHeading?.length}
        fromSearchPage={fromSearchPage}
      >
        <h2>{categoryData?.heading}</h2>
      </BannerTitle>
      {categoryData?.subHeading ? (
        <BannerSubTitle>
          <h2>{categoryData?.subHeading} </h2>
        </BannerSubTitle>
      ) : null}
      <BrowseCatStyled
        fromBabyNames={fromBabyNames}
        columnSize={categoryData?.gridSize || items?.length}
        fromSearchPage={fromSearchPage}
      >
        {items?.map((category, index) => {
          return (
            <Link
              href={{
                pathname: category?.deeplinkValue,
                query: removeDefaultParams(router.query),
              }}
              passHref
              key={index}
              locale={false}
              legacyBehavior
            >
              <BrowseImageBox
                as="a"
                fromSuccessPage={fromSuccessPage}
                onClick={(e) => categoryClickHandler(e, category, index)}
              >
                <Image
                  src={getMobileImage(category)}
                  alt={category.name || ''}
                  className={clickEffect.index === index && clickEffect.class}
                  quality={90}
                  fill
                  sizes="60vw"
                />
                {category.name && (
                  <BrowseCategoryName fromSearchPage={fromSearchPage}>
                    {category.name}
                  </BrowseCategoryName>
                )}
              </BrowseImageBox>
            </Link>
          );
        })}
      </BrowseCatStyled>
    </BrowseCatWrapper>
  );
}
